
function drawLine(context, start, end, color, line_width) {
    context.strokeStyle = color;
    context.lineWidth = line_width;

    context.beginPath();
    context.moveTo(start[0], start[1]);
    context.lineTo(end[0], end[1]);
    context.stroke();
}

function drawCircle(ctx, x, y, radius, stroke, strokeWidth) {
    ctx.beginPath()
    ctx.arc(x, y, radius, 0, 2 * Math.PI, false)
    if (stroke) {
      ctx.lineWidth = strokeWidth
      ctx.strokeStyle = stroke
      ctx.stroke()
    }
  }

function drawPoint(context, x, y, label, color, size) {
    if (color == null) {
        color = '#000';
    }
    if (size == null) {
        size = 5;
    }

    // to increase smoothing for numbers with decimal part
    var pointX = Math.round(x);
    var pointY = Math.round(y);

    context.beginPath();
    context.fillStyle = color;
    context.arc(pointX, pointY, size, 0 * Math.PI, 2 * Math.PI);
    context.fill();

    if (label) {
        var textX = pointX;
        var textY = Math.round(pointY - size - 3);
        
        context.font = 'Italic 14px Arial';
        context.fillStyle = color;
        context.textAlign = 'center';
        context.fillText(label, textX, textY);
    }
}

function getFaceMeshImg(canvas, msg, width, height) {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    drawFaceMesh(ctx, msg)
    return ctx.getImageData(0, 0, width, height)
}

function drawFaceMesh(ctx, face_landmarks ) {
    for (var landmark of face_landmarks) {
        for (var p of landmark) {
            drawPoint(ctx, p.x, p.y, null, 'red', 3)
        }
    }
}

function getHandImg(canvas, msg, width, height) {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    drawHands(ctx, msg)
    return ctx.getImageData(0, 0, width, height)
}

function drawHands(ctx, hands ) {    
    console.log(hands)
    if (undefined == hands) {
        return
    }

    for (var hand_points of hands) {
        [[1, 2], [2, 3], [3, 4]]
        .forEach(function (t, i) {            //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'yellow', 5)
        });

        [2, 3, 4]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p[0], p[1], null, 'yellow', 5)
        });

        [[5, 6], [6, 7], [7, 8]]
        .forEach(function (t, i) {          //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'blue', 5)
        });

        [6, 7, 8]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p[0], p[1], null, 'blue', 5)
        });

        [[9, 10], [10, 11], [11, 12]]
        .forEach(function (t, i) {          //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'green', 5)
        });
        [10, 11, 12]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p[0], p[1], null, 'green', 5)
        });

        [[13, 14], [14, 15], [15, 16]]
        .forEach(function (t, i) {          //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'violet', 5)
        });

        [14, 15, 16]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p[0], p[1], null, 'violet', 5)
        });

        [[17, 18], [18, 19], [19, 20]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'brown', 5)
        });

        [18, 19, 20]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p[0], p[1], null, 'brown', 5)
        });

        [[1, 0], [0, 5], [5, 9], [9, 13], [13, 17], [17, 0]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = hand_points[t[0]]
            let end = hand_points[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });

        [1, 0, 5, 9, 13, 17]
        .forEach(function (index, i) {          //eslint-disable-line no-unused-vars
            let p = hand_points[index]
            drawPoint(ctx, p.x, p.y, null, 'gray', 5)
        });

    }
}


function getPoseImg(canvas, msg, width, height) {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    drawPose(ctx, msg)
    return ctx.getImageData(0, 0, width, height)
}

function drawPose(ctx, pose_landmarks ) {    
    // console.log(pose)
    if (undefined == pose_landmarks) {
        return
    }
    // let pose_points = pose.pose;
    for (var landmark of pose_landmarks) {
        [[8, 6], [6, 5], [5, 4], [4, 0], [0, 1], [1, 2], [2, 3], [3, 7]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[10, 9]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[11, 23], [23, 24], [24, 12], [12, 11]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[11, 13], [13, 15], [15, 17], [17, 19], [19, 15]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[15, 21]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[12, 14], [14, 16], [16, 18], [18, 20], [20, 16]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[16, 22]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        [[24, 26], [26, 28], [28, 30], [30, 32], [32, 28]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
    
        [[23, 25], [25, 27], [27, 31], [31, 29], [29, 27]]
        .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
            let start = landmark[t[0]]
            let end = landmark[t[1]]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        });
    
        landmark
        .forEach(function (xyz, i) {          //eslint-disable-line no-unused-vars        
            drawPoint(ctx, xyz.x, xyz.y, null, 'yellow', 5)
        });    
    }
}

function getDetectionImg(canvas, msg, width, height) {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    drawDetection(ctx, msg)
    return ctx.getImageData(0, 0, width, height)
}

function drawDetection(ctx, detections ) {    
    console.log(detections)
    if (undefined == detections) {
        return
    }
    for (var detection of detections) {
        let lt = [detection.location.x, detection.location.y]
        let rt = [detection.location.x + detection.location.w, detection.location.y]
        let rb = [detection.location.x + detection.location.w, detection.location.y + detection.location.h]
        let lb = [detection.location.x, detection.location.y + detection.location.h]
        drawLine(ctx, lt, rt, 'red', 2)
        drawLine(ctx, rt, rb, 'red', 2)
        drawLine(ctx, rb, lb, 'red', 2)
        drawLine(ctx, lb, lt, 'red', 2)
        
        for (var label of detection.label) {
            ctx.font = '20px serif';
            ctx.fillStyle = "red";
            ctx.fillText(`${label.label}:${parseInt(label.score*100)/100}`, lb[0], lb[1]);
            ctx.fillText(`${detection.id}`, lb[0], lb[1] - 20 );
        }
    }
}

function getIrisImg(canvas, msg, width, height) {
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    drawIris(ctx, msg)
    return ctx.getImageData(0, 0, width, height)
}

function drawIris(ctx, iris_and_eyes ) {
    for (var landmark of iris_and_eyes) {
        let radius1 = Math.sqrt((landmark[0].x - landmark[1].x) ** 2 + (landmark[0].y - landmark[1].y) **2)
        let radius2 = Math.sqrt((landmark[5].x - landmark[6].x) ** 2 + (landmark[5].y - landmark[6].y) **2)
        drawCircle(ctx, landmark[0].x, landmark[0].y, radius1, 'red', 1)
        drawCircle(ctx, landmark[5].x, landmark[5].y, radius2, 'red', 1)

        for (let i = 10; i < 18; i++) {
            let end_index = i + 1
            let start = landmark[i]
            let end = landmark[end_index]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'blue', 1)
        }
        for (let i = 19; i < 25; i++) {
            let end_index = i + 1
            let start = landmark[i]
            let end = landmark[end_index]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'blue', 1)
        }
        drawLine(ctx, [landmark[18].x, landmark[18].y], [landmark[25].x, landmark[25].y], 'blue', 1)
        drawLine(ctx, [landmark[10].x, landmark[10].y], [landmark[19].x, landmark[19].y], 'blue', 1)

        // let count = 0;
        // for (var p of landmark.slice(81, 97)) {
        //     drawPoint(ctx, p.x, p.y, null, 'blue', 1)
        //     ctx.font = '10px serif';
        //     ctx.fillStyle = "red";
        //     ctx.fillText(`${count}`, p.x, p.y);
        //     count++;
        // }

        for (let i = 81; i < 89; i++) {
            let end_index = i + 1
            let start = landmark[i]
            let end = landmark[end_index]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'blue', 1)
        }
        for (let i = 90; i < 96; i++) {
            let end_index = i + 1
            let start = landmark[i]
            let end = landmark[end_index]
            drawLine(ctx, [start.x, start.y], [end.x, end.y], 'blue', 1)
        }
        drawLine(ctx, [landmark[89].x, landmark[89].y], [landmark[96].x, landmark[96].y], 'blue', 1)
        drawLine(ctx, [landmark[81].x, landmark[81].y], [landmark[90].x, landmark[90].y], 'blue', 1)

        // [[23, 25], [25, 27], [27, 31], [31, 29], [29, 27]]
        // .forEach(function (t, i) {              //eslint-disable-line no-unused-vars
        //     let start = landmark[t[0]]
        //     let end = landmark[t[1]]
        //     drawLine(ctx, [start.x, start.y], [end.x, end.y], 'gray', 5)
        // });
    }
}

function drawBase64(ctx, msg) {
    var img = new Image;
    img.onload = function(){
        ctx.globalAlpha = 0.5;
        ctx.drawImage(img, 0, 0); // Or at whatever offset you like
    };
    img.src ='data:image/jpeg;base64,' + msg.base64;
}

export default {
    drawFaceMesh,
    getFaceMeshImg,
    drawHands,
    getHandImg,
    drawPose,
    getPoseImg,
    drawDetection,
    getDetectionImg,
    drawIris,
    getIrisImg,
    drawBase64    
  }